<template>
  <div class="main d-table px-2 py-6">
    <div>
      <div class="float-left ml-4">
        <p class="text-h5 font-weight-black text-blue">PAAS</p>
        <p class="mt-n4 text-body- font-weight-bold">
          Alocação de Aulas a Salas
        </p>
        <p class="text-body-2">
          O PAAS automatiza a alocação de aulas em salas, otimizando
          tempo e recursos no planejamento acadêmico.
        </p>

        <div v-if="!allowPaas">
          <v-btn
            rounded
            color="primary"
            small
            class="bg"
            v-if="!expand"
            @click.stop="expand = true"
            >saiba mais <v-icon>mdi-chevron-down</v-icon></v-btn
          >
        </div>

        <div v-else>
          <v-btn
            rounded
            color="primary"
            class="bg"
            small
            v-if="!expand"
            @click.stop="openPaas"
            >Iniciar</v-btn
          >
          <v-btn
            rounded
            color="primary"
            outlined
            class="ml-4"
            small
            v-if="!expand"
            @click.stop="expand = true"
            >saiba mais <v-icon>mdi-chevron-down</v-icon></v-btn
          >
        </div>
      </div>

      <v-img
        v-if="!expand"
        class="mr-3 mb-2 mt-2 pointer float-right"
        width="200"
        src="../../assets/paas_01.svg"
      ></v-img>
    </div>

    <v-expand-transition>
      <div v-if="expand" class="w-100 d-table px-4 pt-4">
        <div class="w-100 d-table section-about mb-8">
          <v-row>
            <v-col :cols="12" :md="8">
              <div class="float-left ml-4">
                <AssistentCard
                  class="mb-2 mt-4"
                  icon="mdi-lightbulb-question"
                  text="Qual o problema?"
                />
                <p class="text-body-2 py-4 ">
                  O processo tradicional de alocação de aulas em salas
                  na universidade é manual, demorado e sujeito a
                  erros. Ele exige que gestores considerem
                  simultaneamente diversas variáveis como horários,
                  capacidade das salas, requisitos específicos das
                  disciplinas e disponibilidade de espaço. Essa
                  tarefa, especialmente em períodos de matrícula, pode
                  levar dias e ainda gerar conflitos ou uso
                  ineficiente das salas.
                </p>
              </div>
            </v-col>
            <v-col :cols="12" :md="4">
              <v-img
                class="mr-3 mb-2 mt-2 pointer float-right"
                width="200"
                src="../../assets/paas_02.svg"
              ></v-img>
            </v-col>
          </v-row>
        </div>

        <div class="w-100 d-table section-about">
          <v-row>
            <v-col :cols="12" :md="4">
              <v-img
                class="ml-4 mb-2 mt-8 pointer float-left"
                width="200"
                src="../../assets/paas_01.svg"
              ></v-img>
            </v-col>
            <v-col :cols="12" :md="8">
              <div class="float-right ml-4">
                <AssistentCard
                  class="mb-2 mt-4 mr-4 float-right"
                  text="Qual a solução?"
                  position="right"
                />
                <p
                  class="text-body-2 float-right text-right py-4 pr-4"
                >
                  O módulo PAAS automatiza essa tarefa por meio de
                  algoritmos de otimização, realizando a alocação de
                  forma rápida, precisa e de acordo com as restrições
                  definidas. A solução gera resultados que atendem
                  melhor às demandas da instituição, reduz o tempo de
                  trabalho manual e oferece uma interface amigável
                  para uso por servidores e gestores da UFPB,
                  garantindo mais eficiência no planejamento
                  acadêmico.
                </p>
              </div>
            </v-col>
          </v-row>
        </div>

        <div v-if="!allowPaas" class="mt-4">
          <v-btn
            rounded
            color="primary"
            small
            class="bg"
            @click.stop="expand = false"
            >ver menos <v-icon>mdi-chevron-up</v-icon></v-btn
          >
        </div>

        <div v-else class="mt-4">
          <v-btn
            rounded
            color="primary"
            class="bg"
            small
            @click.stop="openPaas"
            >Iniciar</v-btn
          >
          <v-btn
            rounded
            color="primary"
            outlined
            class="ml-4"
            small
            @click.stop="expand = false"
            >ver menos <v-icon>mdi-chevron-up</v-icon></v-btn
          >
        </div>
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
import AssistentCard from "@/components/AssistentCard.vue";
export default {
  name: "AboutSACI",
  components: {
    AssistentCard
  },
  data() {
    return {
      expand: false
    };
  },
  computed: {
    allowPaas() {
      return this.$store.getters.getAllowPaas;
    }
  },
  methods: {
    openPaas() {
      if (this.userIsAdmin || this.allowPaas)
        this.$router.push({ path: "/paas" });
    }
  }
};
</script>

<style scoped>
.main {
  background-color: #f5f5f5;
  width: 100%;
  color: #424242;
  border-radius: 6px;
}

.text-blue {
  color: #0088ff;
}

.clear-both {
  clear: both;
}

.w-100 {
  width: 100%;
}

.section-about {
  background-color: white;
  border: 4px solid #0088ff;
  border-top: 0;
  border-bottom: 0;
  border-radius: 6px;
}

.bg {
  background: linear-gradient(
    45deg,
    #0088ff,
    #2f7dc2,
    #3b3dc9,
    #0088ff
  );
  background-size: 600% 100%;
  animation: gradient 6s linear infinite;
  animation-direction: alternate;
}

@keyframes gradient {
  0% {
    background-position: 0%;
  }
  100% {
    background-position: 100%;
  }
}
</style>
